/**
 * Service module for user permissions
 */
angular
  .module('services.permissions', ['http.permissions'])
  /**
   * A factory with permission functions.
   */
  .factory('permissionService', function (httpPermissions) {
    class PermissionService {
      /**
       * Get current authenticated user permissions from the cache or the server and cache them
       * @returns {Promise<unknown>|null|*} permissions
       */
      static getPermissions() {
        if (this.permissions) {
          return Promise.resolve(this.permissions);
        }
        if (!this.permissionsPromise) {
          this.permissionsPromise = new Promise((resolve, reject) => {
            httpPermissions
              .getPermissions()
              .then(
                (permissions) => {
                  this.permissions = permissions;
                  resolve(this.permissions);
                },
                (err) => {
                  reject(err);
                }
              )
              .finally(() => {
                this.permissionsPromise = null;
              });
          });
        }
        return this.permissionsPromise;
      }

      static hasPermission(permission) {
        return this.getPermissions().then((permissionsObj) => {
          const { permissions, superAdmin } = permissionsObj;
          return !!(permissions.includes(permission) || superAdmin);
        });
      }

      static isSuperAdmin() {
        return this.getPermissions().then((permissionsObj) => {
          const { superAdmin } = permissionsObj;
          return superAdmin;
        });
      }

      static getUserPermissions(userId) {
        return httpPermissions.getUserPermissions(userId);
      }

      static assignPermissions(userId, superAdmin, permissions) {
        return httpPermissions.assignPermissions(userId, superAdmin, permissions);
      }
    }
    return PermissionService;
  });
